<script setup lang="ts">
import SectionListView from '../../views/SectionListView/SectionListView.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';
</script>

<template>
  <BPage>
    <div class="col fit">
      <SectionListView :filter="{ key: 'started_only', value: true }" />
    </div>
  </BPage>
</template>
